import Top from "./projects/top";
import Gnav from "./modules/gnav";
import InView from "./modules/inview";
import Acc from "./modules/acc";
//import Caution from "./modules/caution";
import Copied from "./modules/copied";
import Apply from "./modules/apply";
import Redirect from "./modules/redirect";
import Tracking from "./modules/tracking";

// トラッキングコード挿入
Tracking.init();
// 即時実行
Redirect.init();

function init() {
  Top.init();
  Gnav.init();
  InView.init();
  Apply.init();
  Copied.init();
  Acc.init();
  //Caution.init();
}

export default {
  init,
};
